import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
	dialogContent: {
		paddingBottom: 30,
	},
	heading: {
		fontSize: 48,
		color: theme.palette.secondary.main,
		[theme.breakpoints.down('sm')]: {
			fontSize: 24,
		},
	},
	paragraph: {
		fontSize: 32,
		[theme.breakpoints.down('sm')]: {
			fontSize: 18,
		},
	},
	signUpButton: {
		minHeight: 48,
	},
}));

export default useStyles;
